import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Funcionario } from '../../api.service';
import { ModalPesquisaListaComponent } from '../../shared/modal-pesquisa-lista.component';

@Component({
  selector: 'app-modal-funcionario-exportacao',
  standalone: true,
  imports: [ModalPesquisaListaComponent],
  templateUrl: './modal-funcionario-exportacao.component.html'
})
export class ModalFuncionarioExportacaoComponent {
  @Input() aberta = false;
  @Input() termo = '';
  @Input() funcionarios: Funcionario[] = [];
  @Input() rotuloFuncionario: (item: unknown) => string = () => '';
  @Input() detalheFuncionario: (item: unknown) => string = () => '';

  @Output() termoChange = new EventEmitter<string>();
  @Output() selecionar = new EventEmitter<Funcionario>();
  @Output() limpar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();

  detalheComCpf = (item: unknown) => `CPF ${this.detalheFuncionario(item)}`;

  selecionarFuncionario(item: unknown) {
    this.selecionar.emit(item as Funcionario);
  }
}
